// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"21297302","213":"eebef547","453":"64f059e7","557":"f83a2ed3","810":"0da814cd"}[chunkId] + ".chunk.js";
};